import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { VendorCommandType } from '@kinderlabs-pos/shared-data-type';

export const updateVendorInfoAsync = (rootUrl: string) => async (data: VendorCommandType) =>
	(await posAxiosClient.put<VendorCommandType>(`${rootUrl}/vendor`, data)).data;
